module.exports = __webpack_public_path__ + "img/V6.7f719ae0.jpg";